import React from 'react';
import Header from './Header';
import './assets/fonts/font.css';
import './assets/css/mui.css';
import './assets/css/default.css';
import './assets/css/spinner_dot.css';
import Footer from './Footer';
handelTheme();
//: { children?: React.ReactNode }
export default (props) => (
  <React.Fragment>
 
    <div>
      {/* <Container  style={{maxWidth:window.innerWidth-100+"px"}} > */}
      {props.children}

      {/* </Container> */}
    </div>
    {}
    {/*    */}
  </React.Fragment>
);

function getCurrentSeason() {
  // It's plus one because January is index 0
  const now = new Date();
  const month = now.getMonth() + 1;

  if (month > 3 && month < 6) {
    return 'spring';
  }

  if (month > 6 && month < 9) {
    return 'summer';
  }

  if (month > 9 && month < 12) {
    return 'autumn';
  }

  if (month >= 1 && month < 3) {
    return 'winter';
  }

  const day = now.getDate();
  if (month === 3) {
    return day < 22 ? 'winter' : 'spring';
  }

  if (month === 6) {
    return day < 22 ? 'spring' : 'summer';
  }

  if (month === 9) {
    return day < 22 ? 'summer' : 'autumn';
  }

  if (month === 12) {
    return day < 22 ? 'autumn' : 'winter';
  }
  return 'light';
}
function getDefaultSeason() {
  return 'light';
}
function handelTheme() {
  let CurrentTheme = localStorage.getItem('CurrentTheme');
  if (CurrentTheme === null) {
    import('./assets/css/' + getDefaultSeason() + '.css');
    localStorage.setItem('CurrentBgImageNum', getDefaultSeason() + '.jpg');
  } else {
    import('./assets/css/' + CurrentTheme + '.css');
  }
  /*
    let ChangeBgByRefresh = localStorage.getItem('ChangeBgByRefresh');
    if (ChangeBgByRefresh === null) {
      localStorage.setItem("ChangeBgByRefresh", false);
    }
    else {
      if (ChangeBgByRefresh === "true") {
        let bgNum = Math.floor(Math.random() * 1) + 1;
        let picName = 'bg' + bgNum + '.jpg';
        document.body.style.backgroundImage = "url(" + require('../assets/img/' + picName) + ")";
        localStorage.setItem("CurrentBgImageNum", picName);
      }
      else {
        let picName = localStorage.getItem("CurrentBgImageNum");
        document.body.style.backgroundImage = "url(" + require('../assets/img/' + picName) + ")";
  
      }
    }
      */

  const iFrameDetection = window === window.parent ? false : true;
  if (iFrameDetection) {
    import('./assets/css/iframewindow.css');
  }
}
